<div class="survey-result">
	<div class="survey-result__notice" *ngIf="audience === 'client'">
		<strong>{{ vm.copy.clientTitle }}</strong>
		<div>{{ vm.copy.clientBody }}</div>
	</div>

	<div class="survey-result__notice survey-result__notice--clinical" *ngIf="audience === 'therapist'">
		<strong>{{ vm.copy.therapistTitle }}</strong>
		<div>{{ vm.copy.therapistBody }}</div>
	</div>

	<div class="survey-result__notice survey-result__notice--risk" *ngIf="vm.riskTriggered">
		<strong>{{ vm.copy.riskTitle }}</strong>
		<div>{{ vm.riskMessage }}</div>
	</div>

	<div class="survey-result__card">
		<div class="survey-result__header">
			<div>
				<h2 class="survey-result__title">{{ vm.title }}</h2>
				<div class="survey-result__subtitle" *ngIf="vm.subtitle">{{ vm.subtitle }}</div>
			</div>
			<div class="survey-result__date" *ngIf="vm.completedDate">
				<span>{{ vm.copy.completed }}</span>
				<strong>{{ vm.completedDate }}</strong>
			</div>
		</div>

		<div class="survey-result__scoreRow">
			<div class="survey-result__score" [style.--survey-band-color]="vm.band?.color || '#2e7d32'">
				<span>{{ vm.scoreLabel }}</span>
				<small *ngIf="vm.maxScore">/ {{ vm.maxScore }}</small>
			</div>
			<div class="survey-result__band" [style.--survey-band-color]="vm.band?.color || '#2e7d32'">
				<span class="survey-result__dot"></span>
				{{ vm.band?.label || scoreBandLabel(assignment?.scoreBand) || vm.copy.score }}
			</div>
		</div>

		<p class="survey-result__feedback" *ngIf="vm.feedbackText">{{ vm.feedbackText }}</p>
	</div>

	<div class="survey-result__card" *ngIf="vm.subscales.length">
		<h3 class="survey-result__sectionTitle">{{ vm.copy.subscaleScores }}</h3>
		<div class="survey-result__subscales">
			<div class="survey-result__subscale" *ngFor="let subscale of vm.subscales" [style.--survey-band-color]="subscale.band?.color || '#2e7d32'">
				<div>
					<strong>{{ subscale.label }}</strong>
					<span>{{ subscale.band?.label || '' }}</span>
				</div>
				<div class="survey-result__subscaleScore">{{ subscale.scoreLabel }}<small *ngIf="subscale.maxScore"> / {{ subscale.maxScore }}</small></div>
			</div>
		</div>
	</div>

	<div class="survey-result__card">
		<h3 class="survey-result__sectionTitle">{{ vm.copy.responses }}</h3>
		<div class="survey-result__tableScroll">
			<table class="survey-result__table">
				<thead>
					<tr>
						<th>{{ vm.copy.item }}</th>
						<th>{{ vm.copy.response }}</th>
						<th>{{ vm.copy.score }}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of vm.items" [class.survey-result__riskRow]="item.risk">
						<td><strong>{{ item.order }}</strong> {{ item.text }}</td>
						<td>{{ item.rawValue }} <span *ngIf="item.response">{{ item.response }}</span></td>
						<td>
							{{ item.value }}
							<span *ngIf="item.reversed" class="survey-result__tag">{{ vm.copy.reverseScored }}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
